import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/components/ui/card";
import { IconBackground } from "@/components/ui/icon-background";
import { FloatingAccents } from "@/components/decorative";
import { Briefcase } from "lucide-react";
import { IconBuildingBridge, IconMessages } from "@tabler/icons-react";

const cards = [
  {
    icon: Briefcase,
    titleKey: "valueProps.card1.title",
    descriptionKey: "valueProps.card1.description",
    gradient: "teal" as const,
  },
  {
    icon: IconMessages,
    titleKey: "valueProps.card2.title",
    descriptionKey: "valueProps.card2.description",
    gradient: "orange" as const,
  },
  {
    icon: IconBuildingBridge,
    titleKey: "valueProps.card3.title",
    descriptionKey: "valueProps.card3.description",
    gradient: "green" as const,
  },
];

export const ValueProps = () => {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 md:py-24 px-4 bg-background overflow-hidden">
        <FloatingAccents position="top" />
        
        <div className="container mx-auto max-w-6xl relative z-10">
          <div className="text-center mb-12">
            <h2 className="font-clash text-3xl xs:text-4xl md:text-5xl font-bold text-foreground tracking-tight mb-3">
              {t("valueProps.headline")}
            </h2>
            <p className="text-lg text-muted-foreground/80 font-medium">
              {t("valueProps.tagline")}
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {cards.map((card, index) => (
              <Card key={index}>
                <CardContent className="p-8">
                  <IconBackground 
                    icon={card.icon} 
                    gradient={card.gradient}
                    size="md"
                    className="mb-6"
                  />
                  <h3 className="font-clash text-xl font-semibold mb-3 text-foreground tracking-tight">
                    {t(card.titleKey)}
                  </h3>
                  <p className="text-base text-foreground/80 leading-relaxed tracking-wide font-medium">
                    {t(card.descriptionKey)}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
  );
};
